import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const primary = '#b300b3'

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary,
      },
      dark: {
        primary,
      },
    },
  },
});
